export default __webpack_public_path__ + "static/waves-db7a5b073c5bb43c91dd0884bf1f1476.jpg";